
import { FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { HtmlEditor } from "./HtmlEditor";
import { FormattingToolbar } from "./FormattingToolbar";
import { formatText } from "./utils/textFormatting";
import { UseFormReturn } from "react-hook-form";
import { ProductFormValues } from "./types";

interface ProductFormFieldsProps {
  form: UseFormReturn<ProductFormValues>;
  handleFormat: (format: string, fieldName: 'features') => void;
}

export const ProductFormFields = ({ form, handleFormat }: ProductFormFieldsProps) => {
  return (
    <>
      <FormField
        control={form.control}
        name="name"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Name</FormLabel>
            <FormControl>
              <Input placeholder="Product name" {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      <FormField
        control={form.control}
        name="description"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Description</FormLabel>
            <HtmlEditor name="description" placeholder="Product description" className="min-h-[150px]" />
            <FormMessage />
          </FormItem>
        )}
      />
      <FormField
        control={form.control}
        name="features"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Features</FormLabel>
            <div className="mb-2">
              <FormattingToolbar onFormat={(format) => handleFormat(format, 'features')} />
            </div>
            <FormControl>
              <Textarea 
                placeholder="List the product features here..." 
                className="min-h-[150px]" 
                {...field} 
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      <FormField
        control={form.control}
        name="link"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Product Link</FormLabel>
            <FormControl>
              <Input placeholder="https://example.com/product" {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      <FormField
        control={form.control}
        name="logo"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Product Logo URL</FormLabel>
            <FormControl>
              <Input placeholder="https://example.com/logo.png" {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      <FormField
        control={form.control}
        name="product_screen"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Product Screenshot URL</FormLabel>
            <FormControl>
              <Input placeholder="https://example.com/screenshot.png" {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    </>
  );
};
